var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('component-page', {
    attrs: {
      "title": "Progress linear"
    },
    scopedSlots: _vm._u([{
      key: "basicUsage",
      fn: function fn() {
        return [_c('a-progress-linear', {
          attrs: {
            "value": _vm.basicUsageProgressValue
          }
        }, [_vm._v(" " + _vm._s(_vm.basicUsageProgressValue) + " ")])];
      },
      proxy: true
    }])
  }, [_c('component-usage-example', {
    attrs: {
      "caption": "Indeterminate state"
    }
  }, [_c('a-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }